import { useEffect, useRef } from 'react';

/**
 * Gọi `fn` mỗi `ms` mili giây, chỉ khi `active` đang true.
 *
 * Interval chỉ được tạo lại khi `active` (hoặc `ms`) đổi giá trị — KHÔNG phụ
 * thuộc vào bản thân `fn`. Bug thường gặp: nếu effect liệt kê thẳng một giá
 * trị đổi liên tục (ví dụ đồng hồ đếm ngược cập nhật mỗi giây) vào mảng phụ
 * thuộc, effect sẽ dọn rồi tạo lại interval mỗi lần đổi -> không bao giờ sống
 * đủ lâu để tới mốc `ms`. Hook này giữ `fn` mới nhất qua ref nên gọi lại được
 * hàm mới nhất mà không cần đưa nó vào deps.
 */
const usePollWhile = (active: boolean, fn: () => void, ms: number): void => {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    if (!active) return undefined;
    const timer = setInterval(() => fnRef.current(), ms);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, ms]);
};

export default usePollWhile;
